import { Model } from 'redux-orm';

export default class BaseModel extends Model {
  static create(props) {
    if (props.hasOwnProperty(this.idAttribute) && this.idExists(props[this.idAttribute])) {
      const model = this.withId(props.id);
      const updatedModel = model.update(props);
      return updatedModel || model;
    }
    return super.create(props);
  }
}